import script from "./ai-auto-login-action.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-auto-login-action.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__